/*  imported from AnnouncementElement.module.scss  */

.AnnouncementElement-module__announcement__element___33jar {
  padding: 0.75rem 1rem;
  text-align: left;
  border-radius: 2px;
  display: flex;
  align-items: flex-start;
  font-size: 0.75rem;
  font-weight: 100;
  line-height: 1.5;
}

.AnnouncementElement-module__announcement__element__icon___sJIaU {
  flex: none;
  fill: currentColor;
}

.AnnouncementElement-module__announcement__element__icon__close___2Q_eN {
  margin-top: 0.2rem;
  cursor: pointer;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
}

.AnnouncementElement-module__announcement__element__message___2tnJ8 {
  flex: auto;
  margin-left: 0.75rem;
  margin-right: 2rem;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

.AnnouncementElement-module__announcement__element__link___2Zha7 {
  color: inherit;
  text-decoration: underline;
}
